import { render, staticRenderFns } from "./PBC.vue?vue&type=template&id=f42c567e&scoped=true"
import script from "./PBC.vue?vue&type=script&lang=js"
export * from "./PBC.vue?vue&type=script&lang=js"
import style0 from "./PBC.vue?vue&type=style&index=0&id=f42c567e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42c567e",
  null
  
)

export default component.exports